import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class FootprintEdi_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public FootprintEdi: FootprintEdi_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

